// extracted by mini-css-extract-plugin
module.exports = {"box":"_1FPzy","feature":"_1hrcU","top_but":"_1acP0"};